import TitleUnderlined from "../components/TitleUnderlined";
import AboutUsPngImage from "../img/aboutusImg-cropped.jpg";
import "../styles/aboutus.css";

const aboutUsString1 = "Wij zijn Mats & Tess (of Tess & Mats... daar zijn we nog niet helemaal over uit). Mats is de mastermind achter deze website, terwijl Tess zich liever bezighoudt met het maken van foto's en het schrijven van blogs.";
const aboutUsString2 = "Deze website begon ooit als een manier om iedereen op de hoogte te houden van onze wereldreis in 2023. Inmiddels moeten we het doen met iets minder vakantiedagen per jaar, maar we gaan nog steeds graag op reis en delen onze avonturen hier!";
const aboutUsString3 = "Wil je een e-mail ontvangen zodra er een nieuwe blog online staat? Meld je dan aan via de knop 'Blog melding' op de blogpagina.";
  

const AboutUsPage = () => {
  return (
    <div className="aboutus__page" id="aboutus-page">
      <TitleUnderlined 
        title="Over ons"
        bold={true}
        color="white"
        fontSize="2.5rem"
        className="aboutus__title"
      />
      <div className="aboutus__image-text-container">
        <div className="aboutus__text-container">
          <p className="aboutus__text text">{aboutUsString1}</p>
          <p className="aboutus__text text">{aboutUsString2}</p>
          <p className="aboutus__text text">{aboutUsString3}</p>
          <p className="aboutus__greeting-text">Liefs van ons!</p>
        </div>
        <div className="aboutus__image-container">
          <div className="aboutus__image-controller">
            <img src={AboutUsPngImage} alt="A photo of us" className="aboutus__image"/>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AboutUsPage